export const NEWS = `/v2/guest/news`;
export const NEWS_BY_ID = (id) => `/v2/guest/news/${id}`;
